import { Extent, getCenter } from 'ol/extent';
import { Map } from 'ol';

import * as Geo from './geometry';

let zoomTargetExtent: Extent | null = null;

export function start(extent: Extent | null, map: Map) {
    zoomTargetExtent = extent;
    if (extent) {
        const geometry = Geo.Geometry.fromExtent(Geo.scaleExtent(extent, 4, 4), map);
        map.getView().animate({ center: geometry.center, resolution: geometry.resolution, duration: 500 }, complete => {
            if (complete) {
                zoomTargetExtent = null;
            }
        });
    }
}

export function update(map: Map) {
    let extent = zoomTargetExtent;
    if (extent) {
        const geometry = Geo.Geometry.fromExtent(Geo.scaleExtent(extent, 4, 4), map);
        map.getView().cancelAnimations();
        map.getView().animate({ center: geometry.center, resolution: geometry.resolution, duration: 500 }, complete => {
            if (complete) {
                zoomTargetExtent = null;
            }
        });
    }
}